import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Button } from '@lightspeed/flame/Button';
import { IconDelete } from '@lightspeed/flame/Icon/Delete';
import { TextLink } from '@lightspeed/cirrus-text';
import { Tooltip } from '@lightspeed/flame/Tooltip';

import get from 'lodash/get';
import map from 'lodash/map';
import Table from 'cirrus/Table';

import { getCCTerminalByGatewayConfigID } from 'pages/store/selectors';

const getTableHead = {
  cells: [
    {
      key: 'name',
      content: 'Name',
      className: 'cr-truncate',
      width: '30%',
    },
    {
      key: 'terminalID',
      content: 'Terminal ID',
      className: 'cr-truncate',
      width: '20%',
    },
    {
      key: 'modelNumber',
      content: 'Model Number',
      className: 'cr-truncate',
      width: '25%',
    },
    {
      key: 'serialNumber',
      content: 'Serial Number',
      className: 'cr-truncate',
      width: '25%',
    },
    {
      key: 'delete',
      content: ' ',
      width: '72px',
    },
  ],
};

const getTableBody = (ccTerminals, onEdit, onDelete) =>
  map(ccTerminals, ccTerminal => ({
    key: ccTerminal.ccTerminalID,
    cells: [
      {
        content: (
          <TextLink
            onClick={() => {
              onEdit(ccTerminal.ccTerminalID);
            }}
            title={get(ccTerminal, 'name', 'n/a')}
          >
            {get(ccTerminal, 'name', 'n/a')}
          </TextLink>
        ),
        className: 'cr-bold cr-truncate',
      },
      {
        content: get(ccTerminal, 'configuration.terminalID', 'n/a'),
        className: 'cr-truncate',
      },
      {
        content: get(ccTerminal, 'configuration.modelNumber', 'n/a'),
        className: 'cr-truncate',
      },
      {
        content: get(ccTerminal, 'configuration.serialNumber', 'n/a'),
        className: 'cr-truncate',
      },
      {
        content: (
          <Tooltip content="Unpair terminal">
            <Button
              variant="danger"
              size="small"
              aria-label="Unpair terminal"
              onClick={() => {
                onDelete(ccTerminal.ccTerminalID);
              }}
            >
              <IconDelete />
            </Button>
          </Tooltip>
        ),
      },
    ],
    className: 'cr-gray',
  }));

export const CCTerminalComponent = ({ ccTerminals, onEdit, onDelete }) => (
  <Table
    head={getTableHead}
    body={getTableBody(ccTerminals, onEdit, onDelete)}
    noDataMessage="No terminals were found."
  />
);

CCTerminalComponent.propTypes = {
  ccTerminals: PropTypes.arrayOf(PropTypes.shape()),
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
};

const mapStateToProps = (state, ownProps) => ({
  ccTerminals: getCCTerminalByGatewayConfigID(ownProps.gatewayConfigId)(state),
});

export default connect(mapStateToProps, null)(CCTerminalComponent);
